"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _SystemIcons = require("../SystemIcons");

var _core = require("@emotion/core");

const SvgCloudLightning = props => {
  return (0, _core.jsx)(_SystemIcons.SystemIcons, props, (0, _core.jsx)("path", {
    d: "M25.555 22.168a1 1 0 01.277 1.387L22.87 28H27a1 1 0 01.832 1.555l-4 6a1 1 0 11-1.664-1.11L25.13 30H21a1 1 0 01-.832-1.555l4-6a1 1 0 011.387-.277zM20.995 12A9 9 0 0129.48 18h.519a6 6 0 011.2 11.88 1 1 0 01-.398-1.96A4 4 0 0030 20h-1.26a1 1 0 01-.968-.75 7 7 0 10-10.168 7.875 1 1 0 01-.968 1.75A9 9 0 0120.994 12z",
    id: "cloud-lightning_svg__a"
  }));
};

var _default = SvgCloudLightning;
exports.default = _default;